import {DatePicker, TimePicker} from 'antd'
import locale from 'antd/es/date-picker/locale/it_IT'
import moment from 'moment'
import {Typography} from '@mui/material'

// Legacy-stack twin of pages-new/secondaryAssumptions/NextDoseFieldsNew: date and time of the
// therapy's next dose (therapy-service RF3.3/RF4.4), movable from the deep-link page only. Moving
// it shifts that single dose (and its reminder): the ones after it stay on the usual time.

const LABEL_STYLE = {fontWeight: 600, marginBottom: 8, display: 'block'} as const

interface NextDoseFieldsProps {
  value: string | null
  onChange: (value: string | null) => void
  disabled?: boolean
  error?: boolean
}

const NextDoseFields = ({value, onChange, disabled, error}: NextDoseFieldsProps) => {
  const onPick = (picked: moment.Moment | null) => onChange(picked ? picked.toISOString() : null)

  return (
    <div>
      <Typography variant='body2' style={LABEL_STYLE}>Prossima assunzione</Typography>
      <div style={{display: 'flex', gap: 16, flexWrap: 'wrap'}}>
        <div style={{flex: '1 1 180px'}}>
          <Typography variant='body2' style={LABEL_STYLE}>Data</Typography>
          <DatePicker
            disabled={disabled}
            status={error ? 'error' : undefined}
            format='DD/MM/YYYY'
            locale={locale}
            popupStyle={{zIndex: 1400}}
            style={{width: '100%'}}
            disabledDate={current => current && current.isBefore(moment(), 'day')}
            value={value ? moment(value) : null}
            onChange={onPick}
          />
        </div>
        <div style={{flex: '1 1 180px'}}>
          <Typography variant='body2' style={LABEL_STYLE}>Ora</Typography>
          <TimePicker
            disabled={disabled}
            status={error ? 'error' : undefined}
            format='HH:mm'
            popupStyle={{zIndex: 1400}}
            style={{width: '100%'}}
            value={value ? moment(value) : null}
            onChange={onPick}
          />
        </div>
      </div>
      <Typography variant='caption' color={error ? 'error' : 'textSecondary'} style={{marginTop: 8, display: 'block'}}>
        {error
          ? 'La prossima assunzione deve essere successiva a adesso.'
          : 'Puoi spostare solo la prossima assunzione: le successive restano all\'orario abituale.'}
      </Typography>
    </div>
  )
}

export default NextDoseFields
